import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-start-layout',
  templateUrl: './start-layout.component.html',
  styleUrls: ['./start-layout.component.scss'],
})
export class StartLayoutComponent implements OnInit {

  language$ = this.languageService.language$;
  language: string;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.language$.subscribe(lng => this.language = lng.toUpperCase());
  }

  toggleLanguage() {
    this.language = this.language === 'EN' ? 'SR' : 'EN';
    this.languageService.setLanguage(this.language.toLowerCase());
  }

}
